const Checkmark = () => {
	return (
		<svg xmlns='http://www.w3.org/2000/svg' width='100%' height='100%' viewBox='0 0 24 24' fill='none'>
			<path
				d='M9.94922 20.5723C9.5651 20.5723 9.22656 20.3835 8.93359 20.0059L3.86523 13.5508C3.76758 13.4336 3.69596 13.3164 3.65039 13.1992C3.60482 13.0755 3.58203 12.9551 3.58203 12.8379C3.58203 12.571 3.66992 12.3529 3.8457 12.1836C4.02148 12.0078 4.24609 11.9199 4.51953 11.9199C4.84505 11.9199 5.125 12.0794 5.35938 12.3984L9.91016 18.3555L18.6797 4.38086C18.7969 4.19857 18.9173 4.07161 19.041 4C19.1647 3.92188 19.3242 3.88281 19.5195 3.88281C19.7865 3.88281 20.0013 3.96419 20.1641 4.12695C20.3268 4.28971 20.4082 4.50456 20.4082 4.77148C20.4082 4.88867 20.3887 5.00586 20.3496 5.12305C20.3105 5.23372 20.2487 5.35742 20.1641 5.49414L10.9355 20.0254C10.6947 20.39 10.3659 20.5723 9.94922 20.5723Z'
				fill='#21242D'
			/>
		</svg>
	);
};

export default Checkmark;
